import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-addquestion',
  templateUrl: './addquestion.component.html',
  styleUrls: ['./addquestion.component.css']
})
export class AddquestionComponent implements OnInit {

  
  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  questionColl: any = [];
  questionid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  questionform = new FormGroup({
    questionid: new FormControl(0),
    questionname: new FormControl('', Validators.required),
    questionorderno: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Question";


  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  @Input() questionname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.questionid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.questionform.reset();
      this.fnInitializeQuestion();

      if (this.questionid > 0) {
        this.fngetQuestion();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.questionid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeQuestion() {
    this.questionform.setValue({

      questionid: 0,
      questionname: '',
      questionorderno: null,
      inactive: false,
    })
  }

  //Get 
  fngetQuestion() {

    var data = {
      'questionid': this.questionid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getQuestion(data)
      .subscribe(
        (res) => {
          this.questionColl = res.json().result;
          var editdata = this.questionColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.questionform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'questionid': this.questionid,
          'questionname': this.questionform.get('questionname').value,
          'questionorderno': this.questionform.get('questionorderno').value,
          'companyid': this.loginService.fnGetCompanyId(),         
          'inactive': this.questionform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckQuestion(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.questionform.get('questionid').value > 0) {
                //Update question
                this.fnSetQuestion(data);
              }
              else {
                //Insert question
                this.fnInsertQuestion(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.questionform.controls['questionname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertQuestion(data) {

    this.appService.fnInsertQuestion(data).subscribe(
      (res) => {

        this.saveloading = false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnquestionid = 0;
          if (result.length > 0) {
            rtnquestionid = result[0].questionid
          }
          this.toastr.success('', "The new Question has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, data.questionid);

          this.emitData.emit(rtnquestionid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetQuestion(data) {

    this.appService.fnSetQuestion(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The Question has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.questionid, data.questionname);

          this.emitData.emit(this.questionid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }




  private fnEditMode(deptBO) {

    this.questionform.setValue({

      questionid: deptBO.questionid,
      questionname: deptBO.questionname,     
      questionorderno: deptBO.questionorderno,     
      inactive: deptBO.inactive,
    });

    
    this.picurl = deptBO.questionpicurl;
  
    this.image=null;

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
